/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgPlay64(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={64}
      height={64}
      fill='none'
      viewBox='0 0 64 64'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M32 1C14.906 1 1 14.907 1 32s13.906 31 31 31 31-13.907 31-31S49.094 1 32 1zm10.65 32.182L26.288 44.85a.806.806 0 01-.847.057.835.835 0 01-.44-.74V20.834c0-.31.17-.596.44-.74a.807.807 0 01.847.057l16.364 11.667c.219.156.349.411.349.683 0 .272-.13.526-.35.682z'
      />
    </svg>
  );
}

export default SvgPlay64;
